export enum ReactionType {
  HEART = 'heart',
  HAHA = 'haha',
}

export interface ReactToJobDescriptionPayload {
  jobDescriptionId: string
  reactionType: ReactionType
}
